import React from 'react'
import Hero from '../Components/herosection/herosection';

function Index () {
  return (
    <div>
    <Hero />
    </div>
  )
}

export default Index;
